// Path: client\src\tutorials\playgroundTutorialSteps.js
const playgroundTutorialSteps = [
    {
      element: "#new-playground-checklist",
      intro: "Here you can create a new checklist.",
      position: "bottom",
    },
    {
      element: "#list-of-playground-lists",
      intro: "This is the list of all your checklists. You can view, edit, or delete them here.",
      position: "top",
    },
  ];
  
  export default playgroundTutorialSteps;
  